/* 14 Oct: which order lines are fabricated items (rainwater head / drip tray / custom box) that
   take their own material on the Factory Board. The SAME test as server/fabcut.js fabKind +
   fabDims (the guard checks they agree) - the sums themselves are only on the server. */
export function fabKindOf(it) {
  if (!it || !it.isProduct) return null;
  const c = String(it.category || it.material || "").toLowerCase();
  const kind = /rainwater head/.test(c) ? "head" : /drip tray/.test(c) ? "tray" : /custom box/.test(c) ? "box" : null;
  if (!kind) return null;
  const s = String(it.presetLabel || it.name || "");
  const re = /(?:\b([HWD])\s*(\d+(?:\.\d+)?))|(?:(\d+(?:\.\d+)?)\s*([HWD])\b)/gi;
  const got = {}; let m;
  while ((m = re.exec(s))) got[(m[1] || m[4]).toUpperCase()] = 1;
  return (got.H && got.W && got.D) ? kind : null;
}
export function fabRecordFor(fabMaterial, it, ix) {
  const name = String((it && (it.presetLabel || it.name)) || "");
  return (fabMaterial || []).find(r => r && r.ix === ix && r.name === name) || null;
}
/* one line of words for the screen and the printed sheet */
export function fabRecordWords(r) {
  if (!r) return "";
  if (r.source === "coil") return "Coil " + (r.coilCode || "") + " · " + [r.material, r.colour, r.thickness ? r.thickness + "mm" : ""].filter(Boolean).join(" ")
    + " · pulled " + r.pull.width + " × " + r.pull.length + " (" + r.kg + "kg) · leftover to waste";
  if (r.source === "offcut") return "Offcut " + (r.offcutCode || "") + " · " + [r.material, r.colour, r.thickness ? r.thickness + "mm" : ""].filter(Boolean).join(" ")
    + " · " + r.piece.width + " × " + r.piece.length + " · leftover to waste";
  return "Not in the system: " + (r.note || "");
}
